import { render } from "./CooperateCenter.vue?vue&type=template&id=9b10e0c2&scoped=true"
import script from "./CooperateCenter.vue?vue&type=script&lang=js"
export * from "./CooperateCenter.vue?vue&type=script&lang=js"

import "./CooperateCenter.vue?vue&type=style&index=0&id=9b10e0c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b10e0c2"]])

export default __exports__